import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface SystemApp {
  name: string;
  tag: string;
  image: string;
  points: string[];
}

@Component({
  selector: 'app-sales-overview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sales-overview.html',
  styleUrls: ['./sales-overview.css'],
})
export class SalesOverviewComponent {
  readonly apps: SystemApp[] = [
    {
      name: 'Admin App',
      tag: 'Admin App',
      image: 'images/webps/admin-app.webp',
      points: ['View sales live', 'Control inventory remotely', 'Get alerts', 'Track team performance'],
    },
    {
      name: 'POS System',
      tag: 'POS System',
      image: 'images/webps/pos-app.webp',
      points: ['Fast billing', 'Works offline', 'Supports hardware', 'Auto sync data'],
    },
    {
      name: 'Customer App',
      tag: 'Customer App',
      image: 'images/webps/customer-app.webp',
      points: ['Easy ordering', 'Address & store selection', 'Multiple payment options', 'Rewards system', 'Real-time updates'],
    },
  ];
}
